export default "__VITE_ASSET__1PcomDLE__"